import React from 'react';

import { ExportFormat, ExportOption, ExportOptionProps } from './ExportOption';

type Props = {
  children: React.ReactNode;
};

export const ExportOptions: React.FC<Props> = ({ children }) => {
  const selectedFormats = new Set<string>();
  let initialSelectedFormat: ExportFormat | undefined;

  React.Children.forEach(children, child => {
    if (
      React.isValidElement<ExportOptionProps>(child) &&
      child.type === ExportOption
    ) {
      const { format } = child.props;

      if (selectedFormats.has(format)) {
        throw new Error(`Formato de exportação repetido: ${format}`);
      }

      selectedFormats.add(format);

      if (child.props.startSelected) {
        if (initialSelectedFormat) {
          throw new Error(
            'Somente uma opção de exportação pode iniciar selecionada'
          );
        }

        initialSelectedFormat = format;
      }
    }
  });

  const [selectedFormat, setSelectedFormat] = React.useState<
    ExportFormat | undefined
  >(initialSelectedFormat);

  const options = React.Children.map(children, child => {
    if (
      !React.isValidElement<ExportOptionProps>(child) ||
      child.type !== ExportOption
    ) {
      return child;
    }

    const { format } = child.props;

    return React.cloneElement(child, {
      isSelected: selectedFormat === format,
      onSelect: () => setSelectedFormat(format)
    });
  });

  return (
    <div
      className="btn-group export export-options"
      data-testid="export-options"
      style={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'nowrap',
        gap: '2px'
      }}
    >
      {options}
    </div>
  );
};
